<template>
  <div>
    <div class="card" style="max-width: 100%">
      <div class="card-header">
        <b>Listar Barrios</b>
        <a
          href="http://www.vigilacontigo.com/manuales/manual_configuracion.pdf"
          target="_blank"
          class="float-right"
          v-b-tooltip.hover
          title="Ver Manual"
          ><img
            src="http://www.vigilacontigo.com/manuales/pdf.png"
            style="width: 32px"
        /></a>
      </div>
      <div class="card-body text-dark">
        <div class="row">
          <div class="col-sm-5">
            <b-button
              class="btn btn-add-vg"
              :to="'/configuracion/barrios/crear'"
              ><i class="mdi mdi-plus"></i> Crear Barrio</b-button
            ><br /><br />
          </div>
          <div class="col-sm-6">
            <b-form-input
              class="col-sm-12"
              v-model="filter"
              type="search"
              placeholder="Busqueda"
            ></b-form-input>
          </div>
          <div class="col-sm-1">
            <b-button
              class="btn btn-info"
              style="float: right"
              @click="getBarrios"
              v-b-tooltip.hover
              title="Actualizar Datos"
              ><i class="mdi mdi-replay"></i
            ></b-button>
          </div>
        </div>

        <div class="text-center" v-if="loading">
          <b-spinner variant="primary" label="Text Centered"></b-spinner>
        </div>

        <b-table
          class="table responsive table-bordered"
          stacked="md"
          show-empty
          sticky-header
          small
          :per-page="perPage"
          :items="items"
          :fields="fields"
          :current-page="currentPage"
          :filter="filter"
          @filtered="onFiltered"
        >
          <template #cell(actions)="row">
            <b-button
              class="btn btn-warning"
              :to="'/configuracion/barrios/editar/' + row.item.idbarrio + '/0'"
              v-b-tooltip.hover
              title="Editar Barrio"
              ><i class="mdi mdi-pencil text-white"></i></b-button
            >&nbsp;
            <b-button
              class="btn btn-danger"
              @click="deleteBarrio(row.item)"
              v-b-tooltip.hover
              title="Eliminar Barrio"
              ><i class="mdi mdi-delete"></i
            ></b-button>
          </template>
        </b-table>

        <b-pagination
          v-model="currentPage"
          :total-rows="rows"
          :per-page="perPage"
        ></b-pagination>
      </div>
    </div>
  </div>
</template>
<script>
import { headers } from "./../../../api/headers";
import { configApi } from "./../../../api/configApi";
export default {
  name: "listado_barrios",
  data: () => ({
    title: "",
    perPage: 10,
    filter: null,
    currentPage: 1,
    disabled: false,
    viewModal: false,
    loading: true,
    items: [],
    fields: [
      { key: "idbarrio", label: "ID", sortable: true },
      { key: "barrio", label: "Barrio", sortable: true, class: "text-center" },
      {
        key: "n_comuna",
        label: "Comuna",
        sortable: true,
        class: "text-center",
      },
      { key: "actions", label: "Acciones", class: "text-center" },
    ],
    editedIndex: -1,
  }),
  computed: {
    rows() {
      return this.items.length;
    },
  },

  created() {
    this.getBarrios();
  },

  methods: {
    onFiltered(filteredItems) {
      this.rows = filteredItems.length;
      this.currentPage = 1;
    },
    async getBarrios() {
      return await this.axios
        .get(configApi + "configuracion/barrios", { headers })
        .then((response) => {
          this.items = response.data.data;
          this.loading = false;
        });
    },
    async deleteBarrio(data) {
      let objAlert = {
        titleAlert: "¿Desea eliminar el Barrio?",
        url: configApi + "configuracion/barrios/" + data.idbarrio, // url delete
        headers: { headers },
        messageError: "El Barrio no fue Eliminado",
      };

      this.$Fun.alertaConfirmarEliminarAccion(objAlert, (e) => {
        if (e) {
          this.getBarrios();
        }
      });
    },
  },
};
</script>
